import { BASKET_TYPES, selectBasketList, updateCompany } from 'containers/OrderDetails/basketSlice'
import Summary from 'containers/OrderDetails/Summary/SimplifiedSummary'
import { getCompaniesFields, selectFieldsStatus } from '../formSlice'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { selectIsLoggedIn } from '../../Login/loginSlice'
import { LOCATION_STATES, STATUS } from 'utils/constants'
import { useSelector, useDispatch } from 'react-redux'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { companies, userInfo } from 'rest/urls'
import { useHistory } from 'react-router-dom'
import { GET } from 'rest/request'
import Companies from './Companies'
import NewMagBtn from './NewBtn'
import User from './User'
import '../style.scss'
import './style.scss'

const Billing = ({ isDesktop }) => {
  const list = useSelector(selectBasketList)
  const isLogin = useSelector(selectIsLoggedIn)
  const fieldsStatus = useSelector(selectFieldsStatus)
  const [companyIdx, setCompanyIdx] = useState(undefined)
  const [invoice, setInvoice] = useState(undefined)
  const [data, setData] = useState({
    company: [],
    user: {},
  })

  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { push, replace } = useHistory()

  const menuRef = useRef(null)

  useLayoutEffect(() => {
    if (list?.length === 0) replace('/map')
  }, [list?.length, replace])

  useEffect(() => {
    if (isLogin && fieldsStatus !== STATUS.succeed) dispatch(getCompaniesFields())
  }, [dispatch, fieldsStatus, isLogin])

  useEffect(() => {
    if (isLogin && fieldsStatus === STATUS.succeed) {
      getData().then(() => getData(true))
    }
  }, [fieldsStatus, isLogin])


  const selectData = (_invoice) => {
    if (!_invoice && companyIdx === undefined) return
    const selectedCompany = _invoice || data.company?.[companyIdx]
    dispatch(updateCompany(selectedCompany))
    push('/order/summary')
  }

  const getData = async (user = false) => {
    try {
      const response = await GET(user ? userInfo : companies)
      if (response.data) {
        setData(d => {
          return {
            ...d,
            [user ? 'user' : 'company']: response.data
          }
        })
      }

    } catch (err) {
      console.warn('Fetch: failed')
    }
  }

  return (
    <>
      <div className={`billing ${isDesktop ? '--desktop' : ''}`}>
        <div className='title'>
          <div>{t('form.dataCompletion')}</div>
          <div>{t('form.contractData')}</div>
        </div>

        <div
          ref={menuRef}
          className='billing__main main center'>
          <div className='billing__menu'>
            <div
              className={`menu__item group ${invoice ? '--selected' : ''}`}
              onClick={() => setInvoice(true)}>
              <div className='item__desc'>
                <div>{t('form.invoiceFor')}</div>
                <div>{t('form.company')}</div>
              </div>

              <div className='checkCircle'><i className='icon icon--check'></i></div>
            </div>

            <div
              className={`menu__item group ${invoice === false ? '--selected' : ''}`}
              onClick={() => setInvoice(false)}>
              <div className='item__desc'>
                <div>{t('form.invoiceFor')}</div>
                <div>{t('form.privateIndividual')}</div>
              </div>

              <div className='checkCircle'><i className='icon icon--check'></i></div>
            </div>
          </div>

          {invoice === undefined
            ? isDesktop
              ? null
              : <div className='billing__info'>
                <div className='orderTitle'>
                  <span>{t('basic.justMoment')}</span>
                  <span>{t('basic.doYouNeedMoreSpace')}</span>
                </div>
                <NewMagBtn />
              </div>
            : invoice
              ? <>
                <div className='--element__title'>{t('form.selectCompany')}</div>
                <Companies
                  menuRef={menuRef}
                  data={data?.company}
                  isDesktop={isDesktop}
                  companyIdx={companyIdx}
                  setCompanyIdx={setCompanyIdx}
                  selectData={selectData}
                  getData={getData} />
              </>
              : <User
                user={data.user}
                isDesktop={isDesktop}
                setData={setData}
              />}
        </div>
      </div>

      {isDesktop && <div className='orderInfo__aside'>
        <Summary />
        <div className='orderInfo__buttons'>
          <ArrowBtn
            enlarged
            text={t('basic.next')}
            disabled={invoice === undefined || (invoice && companyIdx === undefined)}
            action={() => {
              if (invoice) {
                selectData()
              } else {
                dispatch(updateCompany(false))
                push('/order/summary')
              }
            }} />
          <BackBtn
            text={t('form.addAnotherWarehouse')}
            action={() => {
              if (list?.some(l => l.type === BASKET_TYPES.rent)) {
                push(window.location.pathname, LOCATION_STATES.popup('newMag'))
              } else {
                push('/shop')
              }
            }}
          />
        </div>
      </div>}
    </>
  )
}

export default Billing